// Environment Detection and Configuration
// This file automatically detects environment and sets correct URLs

const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

// Environment-based configuration
const config = {
  development: {
    backendUrl: 'http://localhost:8001',
    frontendUrl: 'http://localhost:3000',
    stripeKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || null,
    recaptchaEnabled: false,
    recaptchaSiteKey: null,
  },
  preview: {
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'https://kgob-events-release.preview.emergentagent.com',
    frontendUrl: 'https://kgob-events-release.preview.emergentagent.com',
    stripeKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || null,
    recaptchaEnabled: false,
    recaptchaSiteKey: null,
  },
  production: {
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'https://events.kgob.com',
    frontendUrl: 'https://events.kgob.com',
    stripeKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || null,
    recaptchaEnabled: process.env.REACT_APP_RECAPTCHA_ENABLED === 'true',
    recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || null,
  }
};

// Auto-detect environment if not explicitly set
function detectEnvironment() {
  try {
    // Check for explicit env variable
    if (process.env.REACT_APP_ENV) {
      return process.env.REACT_APP_ENV;
    }
    
    // Auto-detect from hostname (safe for Safari/iframe)
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      const hostname = window.location.hostname;
      
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'development';
      }
      
      if (hostname.includes('preview.emergentagent.com') || hostname.includes('emergent.host')) {
        return 'preview';
      }
      
      if (hostname.includes('kgob.com')) {
        return 'production';
      }
    }
    
    // Fallback to env variable or development
    return process.env.NODE_ENV || 'development';
  } catch (error) {
    console.warn('Environment detection failed, using development:', error);
    return 'development';
  }
}

const currentEnv = detectEnvironment();
const currentConfig = config[currentEnv] || config.development;

// Export configuration
export const API_BASE_URL = currentConfig.backendUrl;
export const FRONTEND_URL = currentConfig.frontendUrl;
export const STRIPE_PUBLISHABLE_KEY = currentConfig.stripeKey;
export const RECAPTCHA_ENABLED = currentConfig.recaptchaEnabled;
export const RECAPTCHA_SITE_KEY = currentConfig.recaptchaSiteKey;
export const IS_DEVELOPMENT = currentEnv === 'development';
export const IS_PREVIEW = currentEnv === 'preview';
export const IS_PRODUCTION = currentEnv === 'production';
export const CURRENT_ENV = currentEnv;

// Log configuration in development
if (IS_DEVELOPMENT) {
  console.log('🔧 Environment:', currentEnv);
  console.log('🔧 Backend URL:', API_BASE_URL);
  console.log('🔧 Frontend URL:', FRONTEND_URL);
}

export default {
  API_BASE_URL,
  FRONTEND_URL,
  STRIPE_PUBLISHABLE_KEY,
  RECAPTCHA_ENABLED,
  RECAPTCHA_SITE_KEY,
  IS_DEVELOPMENT,
  IS_PREVIEW,
  IS_PRODUCTION,
  CURRENT_ENV
};
